import React, { useState, useEffect } from 'react';
import Navbar from '../Shared/Navbar';
import api from '../../config/api';
import { Link } from 'react-router-dom';
import './Dashboard.css';

function CreatorDashboard({ user, onLogout }) {
  const [stats, setStats] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [portfolioRes, analyticsRes] = await Promise.all([
        api.get('/api/portfolio'),
        api.get('/api/analytics/creator')
      ]);

      setStats(portfolioRes.data.stats);
      setAnalytics(analyticsRes.data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar user={user} onLogout={onLogout} userType="creator" />
        <div className="dashboard-container">
          <div className="loading">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Navbar user={user} onLogout={onLogout} userType="creator" />
      
      <div className="dashboard-container">
        <div className="dashboard-header">
          <div>
            <h1>Welcome back, {user.name}!</h1>
            <p className="text-gray-600">Here's an overview of your portfolio activity</p>
          </div>
          <Link to="/creator/import" className="btn btn-primary">
            + Import New Work
          </Link>
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#dbeafe' }}>
              📁
            </div>
            <div>
              <div className="stat-value">{stats?.totalProjects || 0}</div>
              <div className="stat-label">Projects</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#fef3c7' }}>
              🖼️
            </div>
            <div>
              <div className="stat-value">{stats?.totalAssets || 0}</div>
              <div className="stat-label">Assets</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#d1fae5' }}>
              👁️
            </div>
            <div>
              <div className="stat-value">{stats?.profileViews || 0}</div>
              <div className="stat-label">Profile Views</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#e0e7ff' }}>
              🏢
            </div>
            <div>
              <div className="stat-value">{stats?.brandViews || 0}</div>
              <div className="stat-label">Brand Views</div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions">
          <h2>Quick Actions</h2>
          <div className="action-grid">
            <Link to="/creator/import" className="action-card">
              <div className="action-icon">📤</div>
              <h3>Import Work</h3>
              <p>Upload new designs and projects</p>
            </Link>

            <Link to="/creator/curation" className="action-card">
              <div className="action-icon">🏷️</div>
              <h3>Review AI Tags</h3>
              <p>Curate and refine auto-generated tags</p>
            </Link>

            <Link to="/creator/portfolio" className="action-card">
              <div className="action-icon">✏️</div>
              <h3>Edit Portfolio</h3>
              <p>Manage projects and visibility</p>
            </Link>
          </div>
        </div>

        {/* Recent Activity */}
        {analytics?.engagement && (
          <div className="card" style={{ marginTop: '2rem' }}>
            <h2>Portfolio Views (Last 7 Days)</h2>
            <div className="chart-container">
              {analytics.engagement.lastWeek.map((day) => (
                <div key={day.date} className="chart-bar-wrapper">
                  <div
                    className="chart-bar"
                    style={{
                      height: `${(day.views / Math.max(...analytics.engagement.lastWeek.map(d => d.views))) * 100}%`
                    }}
                  ></div>
                  <div className="chart-label">{new Date(day.date).getDate()}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Top Projects */}
        {analytics?.topProjects && (
          <div className="card" style={{ marginTop: '2rem' }}>
            <h2>Top Performing Projects</h2>
            <div className="table-responsive">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Project Name</th>
                    <th>Views</th>
                    <th>Interactions</th>
                  </tr>
                </thead>
                <tbody>
                  {analytics.topProjects.map((project, idx) => (
                    <tr key={idx}>
                      <td>{project.name}</td>
                      <td>{project.views}</td>
                      <td>{project.interactions}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CreatorDashboard;
